// SCRUM-922: seasonal Sign-in themes. A theme is ON only inside its date
// window (Pacific time, same convention as DatePicker.js / SCRUM-407) and
// automatically OFF outside it, so the standard login screen comes back on
// its own once the season is over - no deploy needed.
//
// Windows are month/day only (inclusive) so they repeat every year.
// month is 1-based (10 = October). An optional hour (0-23, Pacific) narrows
// a boundary day: `from` starts at that hour, `to` runs through the end of
// that hour. Without it, `from` starts at 12:00 AM and `to` runs all day.
const SEASONAL_THEMES = [
  // Runs into Nov 1 until Thanksgiving takes over at 2:00 AM.
  { name: "halloween", from: { month: 10, day: 1 }, to: { month: 11, day: 1, hour: 1 } },
  // SCRUM-933: replaces Halloween at 2:00 AM Nov 1; Christmas takes over on Dec 1.
  { name: "thanksgiving", from: { month: 11, day: 1, hour: 2 }, to: { month: 11, day: 30 } },
];

// QA/preview override: /login?theme=halloween (or thanksgiving) forces a theme on any date,
// /login?theme=standard forces the plain screen inside a window.
const STANDARD = "standard";

const toMonthDayHour = ({ month, day, hour }) => month * 10000 + day * 100 + hour;

const getPacificNow = () =>
  new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

// Returns the active theme name, or null for the standard screen. Any failure
// (bad date, unsupported time zone) falls back to null = standard screen.
export const getActiveSeasonalTheme = (search = "") => {
  try {
    const override = new URLSearchParams(search).get("theme");
    if (override === STANDARD) return null;
    if (override && SEASONAL_THEMES.some((t) => t.name === override)) {
      return override;
    }

    const now = getPacificNow();
    if (Number.isNaN(now.getTime())) return null;
    const current = toMonthDayHour({
      month: now.getMonth() + 1,
      day: now.getDate(),
      hour: now.getHours(),
    });

    const active = SEASONAL_THEMES.find(
      (t) =>
        current >= toMonthDayHour({ hour: 0, ...t.from }) &&
        current <= toMonthDayHour({ hour: 23, ...t.to })
    );
    return active ? active.name : null;
  } catch {
    return null;
  }
};
